import typeCheck from 'common/util/typeCheck';

import {
  INCOME_VERIFICATION_DEFAULT_PROVIDER,
} from 'common/incomeVerificationConstants';

import {
  SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
} from 'api/actionTypes';

export default async function createScreeningGroup(
  { state, apiClient },
  { listingId, userIds },
) {
  typeCheck('userIds::NonEmptyArray', userIds);
  typeCheck('listingId::PositiveNumber', listingId);

  const incomeVerificationGroup = await apiClient.postWithState({
    action: SR_API_ACTION_INCOME_VERIFICATION_CREATE_SCREENING,
    state: state,
    payload: {
      userIds,
      listingId,
      provider: INCOME_VERIFICATION_DEFAULT_PROVIDER,
    },
  });

  incomeVerificationGroup.incomeVerifications.forEach((incomeVerification) => {
    state.set(['incomeVerifications', 'activeByUserId', incomeVerification.userId], incomeVerification);
  });

  return incomeVerificationGroup;
}
